export const interestedInOptions = [
  'Sponsorship',
  'Non-profit',
  'Manufacturer/Supplier/Distributor',
];

export const categoryOptions = [
  '',
  'Beauty',
  'Fitness + Wellness',
  'Home',
  'Fashion',
  'Tech',
  'Experience',
];

export const subcategoryOptions = [
  '',
  'Bath & Body',
  'Hair',
  'Makeup',
  'Nails',
  'Skincare',
  'Tools & Brushes',
  'Fragrance',
  'Fitness',
  'Oral Care',
  'Food',
  'Drinks',
  'Health Care',
  'Personal Care',
  'Aromatherapy',
  'Furniture',
  'Outdoor',
  'Bedding',
  'Bath',
  'Lighting',
  'Pillows & Decor',
  'Kitchen & Dining',
  'Storage & Organization',
  'Rugs',
  'Jewelry & Watches',
  'Accessories',
  'Bags',
  'Shoes',
  'Apparel',
  'Camera, Photo & Video',
  'Headphones',
  'Speakers',
  'Wearable Technology',
  'Cell Phones & Accessories',
];

export const disclaimer =
  'By submitting the information ("Submission"), I acknowledge and agree that: (a) FabFitFun reviews, manufactures and/or distributes a number of products sold under a variety of brands (collectively, “FFF Products”), and (b) FFF has suggested to it by third parties many products, concepts, and techniques relating to FFF Products.  Accordingly, I recognize and agree that any products, concepts, and techniques relating to FFF Products that I or my company may disclose to FFF, whenever and however disclosed (collectively, “FFF Product Concepts”), are likely to be similar or identical to, in whole or in part, and may compete with some such developed and suggested concepts. I therefore agree that: (i) no Submission by me or my company to FFF of FFF Product Concepts (in any form and however identified or marked, regardless of whether FFF objects to any such identification or marking) is made in confidence or constitutes my or my company’s Confidential Information, and (ii) no express or implied obligation of any kind is assumed by FFF with respect thereto. I also agree that FabFitFun may use, copy, redistribute and disclose the Submission for any purpose in any manner, without compensation to me or any other person or party.  FabFitFun shall have no obligations concerning the Submission, including no obligation to review the Submission, return any materials, or acknowledge receipt of the Submission.  If you do not agree to these terms, please do not send us any Submissions.';
